import { configureAmplify } from "@repo/amplify-config";

const amplifyConfig = configureAmplify();

export default amplifyConfig;
